import React from "react";
import {Helmet} from "react-helmet";

export default function Instinct() {
    return (
        <div>
            <Helmet>
                <title>拒绝成长 Refuse to Grow</title>
            </Helmet>
            <h6 className="App-essay-title">拒绝成长</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二六 一月</b>
                <br/><br/>
                在今天的文化里，人的成长不是生命奇迹，而是一个待办事项，这让人倒胃口。
                <br/><br/>
                所以我拒绝这种成长。
                <br/><br/>
                一颗种子发芽长成参天大树，一个婴儿长大成人，潮涨潮息，花开花落，大自然无数奇观蕴含的神奇力量，被理智解释成明确的因果规律，甚至更糟糕：一项待完成的使命。
                <br/><br/>
                让我们做个实验，假如我追求成长，而成长又需要挫折和愈合，那最合理的“成长方式”就需要：主动寻找打断自己双腿的机会，给自己配一副拐，然后期待愈合后的双腿更强壮有力。这和中世纪黑暗的教会统治有何区别？
                <br/><br/>
                自我成长在近乎自残的行为中被完成，这让“自我成长”可怖又扭曲。如果必须成长为某种面目的人，才能拥有在社会生存的权利，那这种压迫性的社会需求，势必会在未来的某一刻，要求人“主动打断自己双腿”以寻求所谓的成长机会。
                <br/><br/>
                这种暴力倾向给精神操控留足了施展拳脚的空间，这种倾向也严重破坏了自然成长所需要的随机性和自由。
                <br/><br/>
                如果仔细观察另一种非理性的力量，比如直觉，就会发现人的直觉和感受才是真实存在的：无法剥夺，无法歪曲，无法否定，人的直觉时常拥有发号施令的最强资格——现实中也正是如此。但人们经常对直觉感受冠以“非理性”或“不成熟”的名号，进行污名化。因为人更偏好有限可推理的理智，而非无穷又难描摹的直觉。
                <br/><br/>
                但让我们再看一眼现实世界：不是条理分明的理性，也不是自我摧残的成长，经常是我们的直觉感受决定了我们最终如何与世界互动。所以现实中，并非我“该”做什么或我“该”成为什么，最终决定了我们是谁；反而往往，是我“想”做什么以及我“想”成为什么的深层冲动，塑造了我们是谁。
                <br/><br/>
                强迫自我改造的“主动成长”，这种自我催促的自残行为造就了一副强健但扭曲的肌肉神经。
                <br/><br/>
                是时候拒绝这种“追求成长”的病态观念。成长是人对随机世界做出的一系列适应反应。现实世界的随机性构成了成长的唯一养分，因此成长必须自由。
                <br/><br/>
                在现代社会，人依然是动物，只要每天能获取一定热量，夜晚有遮风挡雨的地方，成长压根不是生存的必需品。成长只是适应这一切的副产品。
                <br/><br/>
                <i style={{ color: 'grey' }}>
                    He who has a why to live can bear almost any how.
                    <br/>
                    一个知道自己为什么而活的人，几乎能承担任何如何活的问题。
                    <br/><br/>
                    —— Friedrich Nietzsche 弗里德里希·尼采
                </i>
                <br/><br/>
                人的目的不是为了成长，人的目的是过一种不后悔的生活。

            </p>

            <br/>

            <h6 className="App-essay-title">Refuse to Grow</h6>
            <p className="App-essay-article">
                <br/>
                <b>Jan 2026</b>
                <br/><br/>

            </p>
        </div>)
}
